import { render, staticRenderFns } from "./PlugIcon.vue?vue&type=template&id=798d32c2&scoped=true&"
import script from "./PlugIcon.vue?vue&type=script&lang=js&"
export * from "./PlugIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d32c2",
  null
  
)

export default component.exports